import { ref, reactive, onBeforeMount, watch, getCurrentInstance } from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import inventoryPrivilegeFormModel from "@/models/inventory/inventory-privilege-form";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";

export default function useManageStockReward(props) {
  const vm = getCurrentInstance().proxy;
  const QUANTITY_ADD = 1
  const QUANTITY_WITHDRAW = 2
  const {fetchPrivilegeEntryDetail , fetchPrivilegeEntryEditReward} = inventoryPrivilegeFormModel();
  const {
    openDefaultErrorModal,
    openErrorModal,
    openSuccessModal,
    openWarningModal
  } = useValidationModal();

  const formReward = reactive({
    entryId : "",
    name : "",
    reference : "",
    privilegeType : "",
    image : "",
    note : "",
    status : 1,
  })

  const loading = reactive({
    form : false
  })

  const formManageStock = reactive({
    beforeStockMode : 1,
    stockMode : 1,
    removalStrategy : 1
  })

  const disabledForm = reactive({
    stockMode : false
  })

  const selected = ref(QUANTITY_ADD);
  const qtyTotal = ref(0);
  const quantityValue = reactive({
    add : 0,
    withdraw : 0
  })

  const stockModeOptions = ref([
    { label: "None", value: 1 },
    { label: "Overselling", value: 2 },
    { label: "Restricted", value: 3 },
  ]);

  const removalOptions = ref([
    { label: "FIFO", value: 1 },
    { label: "FEFO", value: 2 },
    { label: "LIFO", value: 3 },
  ])

  const updateAddQuantity = (number) => {
    quantityValue.add = number
  }

  const updateWithdraw = (number) => {
    quantityValue.withdraw = number
  }

  const onModalOpen = () => {
    
  };

  watch(selected , () => {
    quantityValue.add = 0
    quantityValue.withdraw = 0
  })

  const fetchReward = () => {
    let reward = props.rewardDetail
    fetchPrivilegeEntryDetail.payload.Inventory_Id = router.currentRoute.params.ref
    fetchPrivilegeEntryDetail.payload.Privilege_Id = reward.privilege_id
    store.dispatch('api/apiRequest' , fetchPrivilegeEntryDetail).then(response => {
      if(response.status == "success"){
        let resp = response.data.resp
        formReward.entryId = resp.entry_id
        formReward.name = resp.privilege.name_en
        formReward.reference = resp.privilege.alt_reference
        formReward.image = resp.privilege.image_url
        formReward.privilegeType = resp.privilege.type_desc
        formReward.status = resp.privilege.status
        qtyTotal.value = resp.remaining_qty
        formManageStock.stockMode = resp.stock_mode
        formManageStock.beforeStockMode = resp.stock_mode
        formManageStock.removalStrategy = resp.fullfillment_mode
        if(resp.stock_mode != 1){
          disabledForm.stockMode = true;
        }
      }
    }).catch(error => {
    }).finally(() => {

    })
  }

  const resolveStatusLabel = (status) => {
    switch (status) {
      case 1:
        return "Active";
      case 2:
        return "Inactive";
      default:
        return "Unknown";
    }
  };

  const resolveStatusClass = (status) => {
    switch (status) {
      case 1:
        return "active-icon";
      case 2:
        return "inActive-icon";
      default:
        return "Unknown";
    }
  };

  const onSubmitPrivilegeToInventory = () => {
    if(formManageStock.beforeStockMode != formManageStock.stockMode){
      openWarningModal(
        `หากยืนยันแล้ว 
        จะไม่สามารถแก้ไข Stock Mode ได้`,
        `ต้องการยืนยันใช่หรือไม่ ?`,
        () => {
          fetchEditEntryPrivilege();
        },
      )
    } else {
      fetchEditEntryPrivilege();
    }
  }

  const fetchEditEntryPrivilege = () => {
    loading.form = true;
    let payload = {
      Entry_Id: formReward.entryId, 
      Stock_Mode: formManageStock.stockMode, 
      Fullfillment_Mode: formManageStock.removalStrategy,
      Minimun_Qty: 0,
      Req_IdentityId: 1,
      Type: selected.value == QUANTITY_ADD ? "add" : "withdraw", 
      Qty: selected.value == QUANTITY_ADD ? quantityValue.add : quantityValue.withdraw,
      Note: formReward.note,
      Removal_Stategy: formManageStock.removalStrategy,
    }
    fetchPrivilegeEntryEditReward.payload = payload
    store.dispatch('api/apiFormRequest' , fetchPrivilegeEntryEditReward).then(response => {
      openSuccessModal(
        'ทำรายการสำเร็จ !',
        null,
        'ตกลง',
        () => vm.$emit('onAddPrivilege'),
        () => vm.$emit('onAddPrivilege')
    )
    }).catch(error => {
      openDefaultErrorModal(error);
    }).finally(() => {
      loading.form = false;
    })
  }

  const onCloseModal = () => {
    vm.$emit('onCloseModal');
  };

  onBeforeMount(() => {
    fetchReward();
  });

  return {
    formReward,
    formManageStock,
    QUANTITY_ADD,
    QUANTITY_WITHDRAW,
    selected,
    quantityValue,
    stockModeOptions,
    removalOptions,
    qtyTotal,
    disabledForm,
    loading,
    onModalOpen,
    updateAddQuantity,
    updateWithdraw,
    onSubmitPrivilegeToInventory,
    resolveStatusLabel,
    resolveStatusClass,
    onCloseModal
  };
}
